import { Box, BoxProps } from 'reflexbox';
import styled from 'styled-components';
import { mix } from 'polished';

import { MoreIcon } from '@treams/treams-icons';

const Container = styled(Box)`
	background: ${(props) => props.theme.colors.lightBlue};
	border-radius: 12px;

	svg {
		display: block;
		width: 24px;
		height: 24px;

		path {
			fill: ${(props) => props.theme.colors.slateBlue};
		}
	}

	&:hover {
		background: ${(props) =>
			mix(0.5, props.theme.colors.lightBlue, props.theme.colors.lightBlueDark)};

		&:active {
			background: ${(props) => props.theme.colors.lightBlueDark};
		}
	}
`;

export function MoreButton(props: JSX.IntrinsicElements['div'] & BoxProps) {
	return (
		<Container {...props}>
			<MoreIcon />
		</Container>
	);
}
